import { Pipe, PipeTransform } from '@angular/core';

const { baseUrl } = window as { baseUrl?: string };

@Pipe({
	name : 'apiurl'
})
export class ApiurlPipe implements PipeTransform {
	baseUrl = baseUrl;

	transform(url: string): string
	{
		if (url && url.match(/^http[s]*:\/\//)) {
			return url;
		}

		// Callers pass root-relative paths too ('/organizationlogo/1')
		return (this.baseUrl || '').replace(/\/+$/, '') + '/' + (url || '').replace(/^\/+/, '');
	}
}
